import { Button, Card, Form, FormInstance } from 'antd';

import { useEffect, useState } from 'react';

import { InputInterface } from '../utils/forms/FormInterface';
import SubTitleModal from './SubTitleModal';

interface processProps {
  formInput: InputInterface;
  index: number;
  parentForm: FormInstance;
  isCreateMode?: boolean;
  additionalData?: any;
  formDetails?: any;
}

const PackageProcess = (props: processProps) => {
  const { isCreateMode, parentForm, formDetails } = props;
  const [form] = Form.useForm();
  const [currentSubTitle, setCurrentSubTitle] = useState<any>(null);
  const [subTitles, setSubTitles] = useState<any>([]);
  const [openSubTitleModal, setOpenSubTitleModal] = useState<boolean>(false);

  const handleDeleteSubTitles = (index: number) => {
    const updatedSubTitles = subTitles;
    updatedSubTitles.splice(index, 1);
    setSubTitles(() => [...updatedSubTitles]);
    parentForm.setFieldValue('subtitle', subTitles);
    form.setFieldValue(`${index}-heading`, '');
    form.setFieldValue(`${index}-description`, '');
    form.setFieldValue(`${index}-sequence`, '');
    setCurrentSubTitle(null);
  };

  useEffect(() => {
    if (!formDetails) {
      return;
    }
    setSubTitles(formDetails?.subtitle);
    parentForm.setFieldValue('subtitle', formDetails?.subtitle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDetails]);

  return (
    <div>
      <Form.Item
        name={'subtitle'}
        label="Add Sub Headings"
        wrapperCol={{ span: 8, offset: 4 }}
        labelCol={{ span: 4 }}
        labelAlign="left"
      >
        <Card
          key={1}
          style={{
            borderRadius: '8px',
            border: 'solid 1px #d9d9d9',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {subTitles?.map((subTitle: any, index: number) => (
                <div
                  style={{
                    padding: '8px 14px',
                    cursor: 'pointer',
                    backgroundColor: '#80808029',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    minWidth: '100px',
                  }}
                  key={subTitle?.id}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setCurrentSubTitle(index);
                      setOpenSubTitleModal(!openSubTitleModal);
                    }}
                  >
                    {subTitle?.heading}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      padding: '2px 4px',
                      borderRadius: '4px',
                      backgroundColor: '#80808040',
                    }}
                    onClick={() => handleDeleteSubTitles(index)}
                  >
                    X
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{
                  backgroundColor: '#586f80',
                  color: 'white',
                  borderRadius: '4px',
                  border: 'none',
                }}
                onClick={() => setOpenSubTitleModal(!openSubTitleModal)}
              >
                + Add Sub Headings
              </Button>
            </div>
          </div>
        </Card>
      </Form.Item>
      <SubTitleModal
        subTitles={subTitles}
        isCreateMode={isCreateMode}
        setSubTitles={setSubTitles}
        openSubTitleModal={openSubTitleModal}
        currentSubTitle={currentSubTitle}
        parentForm={parentForm}
        childFrom={form}
        setCurrentSubTitle={setCurrentSubTitle}
        setOpenSubTitleModal={setOpenSubTitleModal}
      />
    </div>
  );
};

export default PackageProcess;
